import React from 'react';

type Props = {
  type: string,
  name: string,
  label?: string,
  placeholder?: string,
  error?: boolean,
  onBlur?: Function,
  onChange: Function,
  labelDataId?: string,
  inputDataId?: string,
  value: string,
};

function Input(props: Props) {
  const {
    type,
    name,
    label,
    placeholder,
    error,
    onBlur,
    onChange,
    labelDataId,
    inputDataId,
    value,
  } = props;
  const inputClass = error ? 'form-input form-input--error' : 'form-input';
  return (
    <div className={inputClass}>
      {/* conditional label */}
      {label && (
        <label className="form-input__label" htmlFor={name}>
          <span
            className="form-input__label-content"
            data-automation-id={labelDataId && labelDataId}
          >
            {label}
          </span>
        </label>
      )}
      <input
        className="form-input__field"
        type={type}
        id={name}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        data-automation-id={inputDataId && inputDataId}
        value={value}
      />
    </div>
  );
}

Input.defaultProps = {
  label: null,
  placeholder: null,
  error: false,
  onBlur: null,
  labelDataId: null,
  inputDataId: null,
};

export default Input;
